module.exports = __webpack_public_path__ + "img/drop-down-icon-close.b85d7a94.png";